const ImageInfoType = require("../enums/ImageInfoType");
const PrerenderedImageInfoKey = require("../enums/PrerenderedImageInfoKey");
const {
  generateTemperatureRangeObject,
  generateTemperatureObject,
  generateImageInfoObject,
} = require("./ObjectGenerators");

/**
 * Generate image info
 * @param {Object} infoJSON info.json file contents from .is2 file
 * @param {Number} date_taken_milliseconds Timestamp of when the image was taken
 * @returns {Array} List of image info
 */
const generateImageInfo = (infoJSON, date_taken_milliseconds) => {
  const imageInfoList = [];

  // Validate the date_taken_milliseconds parameter
  if (typeof date_taken_milliseconds !== "number") {
    throw new Error("date_taken_milliseconds must be a number");
  }

  imageInfoList.push(
    generateImageInfoObject(
      PrerenderedImageInfoKey.DATE_AND_TIME,
      ImageInfoType.MILLISECONDS,
      date_taken_milliseconds
    )
  );

  const thermalCameraInfo = infoJSON?.THERMAL_IMAGER_INFO_DATA;
  const sensorWidth = thermalCameraInfo?.irSensorWidth;
  const sensorHeight = thermalCameraInfo?.irSensorHeight;
  imageInfoList.push(
    generateImageInfoObject(
      PrerenderedImageInfoKey.IR_SENSOR_SIZE,
      ImageInfoType.STRING,
      `${sensorWidth} x ${sensorHeight}`
    )
  );

  const thermalImageInfo = infoJSON?.THERMAL_IMAGE_INFO_DATA[0];
  const backgroundTemperatureCelsius =
    thermalImageInfo?.capturedBackgroundTempC;
  imageInfoList.push(
    generateImageInfoObject(
      PrerenderedImageInfoKey.BACKGROUND_TEMPERATURE,
      ImageInfoType.TEMPERATURE,
      generateTemperatureObject(backgroundTemperatureCelsius)
    )
  );

  const emissivity = thermalImageInfo?.capturedEmissivity;
  imageInfoList.push(
    generateImageInfoObject(
      PrerenderedImageInfoKey.EMISSIVITY,
      ImageInfoType.STRING,
      `${emissivity}`
    )
  );

  const transmission = thermalImageInfo?.capturedTransmissionFactor;
  imageInfoList.push(
    generateImageInfoObject(
      PrerenderedImageInfoKey.TRANSMISSION,
      ImageInfoType.STRING,
      `${transmission}`
    )
  );

  const calibrationData = infoJSON?.CALIBRATION_DATA;
  const calRangesInfo = calibrationData?.calRangesInfo?.[0];
  const calRangeMinTempC = calRangesInfo?.calRangeMinTempC;
  const calRangeMaxTempC = calRangesInfo?.calRangeMaxTempC;
  imageInfoList.push(
    generateImageInfoObject(
      PrerenderedImageInfoKey.CALIBRATION_RANGE,
      ImageInfoType.TEMPERATURE_RANGE,
      calRangeMaxTempC != null && calRangeMinTempC != null
        ? generateTemperatureRangeObject(calRangeMinTempC, calRangeMaxTempC)
        : null
    )
  );

  const cameraSerialNumber = `${thermalCameraInfo?.cameraSerialNumber}`;
  imageInfoList.push(
    generateImageInfoObject(
      PrerenderedImageInfoKey.CAMERA_SERIAL,
      ImageInfoType.STRING,
      cameraSerialNumber
    )
  );

  const cameraModel = cameraSerialNumber.split("-")[0];
  imageInfoList.push(
    generateImageInfoObject(
      PrerenderedImageInfoKey.CAMERA_MODEL,
      ImageInfoType.STRING,
      cameraModel
    )
  );

  const manufacturer = thermalCameraInfo?.companyName;
  imageInfoList.push(
    generateImageInfoObject(
      PrerenderedImageInfoKey.CAMERA_MANUFACTURER,
      ImageInfoType.STRING,
      `${manufacturer}`
    )
  );

  return imageInfoList;
};

module.exports = {
  generateImageInfo,
};
